const heConstants = {
  HeTableRowCurrency: 'currency',
  HeTableRowPercentage: 'percentage',
  HeTableRowDays: 'days',
  HeTableRowTime: 'time',
};

export default heConstants;
